const initialJSon = []

const menuReducer = (state = initialJSon, action)=>{

    if(action.type === "update_menu"){
        return [...state, ...action.payload] ;
    }else if(action.type === "reset_menu"){
        return []
    };

    return state;

};

export default menuReducer;